import type { User } from '@tier4/webauto-auth-frontend-client';
import { atom } from 'jotai';

const userAtom = atom<User | undefined>(undefined);

export default userAtom;
